import { FC, useMemo } from 'react'
import { ProducerMapCardProps as Props } from 'components/producers/producer-map-card/types'
import { useRouter } from 'next/router'
import ProducerLocation from 'components/producers/producer-location/ProducerLocation'
import styles from './ProducerMapCard.module.scss'
import { CapacityState } from 'types/producer'
import { getCapacityState, getProducerLocation } from 'utils/producers'
import { useTranslation } from 'next-i18next/pages'
import ProducerCta from 'components/producers/producer-cta/ProducerCta'
import { isReserved as getIsReserved } from 'utils/producers'
import { useStoreSelector } from 'hooks/store'
import { ProgressIndicator } from '@boltenergy-be/design-system'

const ProducerMapCard: FC<Props> = ({ location }) => {
  // REDUX STORE
  const { inputs, flows } = useStoreSelector((store) => store.customer)

  // Next router
  const { locale } = useRouter()

  // i18n
  const { t } = useTranslation('producer')

  // Contants
  const capacityState = useMemo<CapacityState>(
    () => getCapacityState(location, inputs.simulation, flows.simulation.didSimulation),
    [location, inputs.simulation, flows.simulation.didSimulation]
  )
  const isReserved = useMemo<boolean>(() => getIsReserved(location), [location])

  return (
    <div className={styles.card}>
      <strong className="h4 serif">{location.name[locale]}</strong>
      <div className={styles['producer-location-container']}>
        <ProducerLocation
          energyType={location.energyType}
          location={getProducerLocation(locale, location?.location)}
          className={styles.location}
        />
      </div>
      <p className={styles.percentage}>
        {t('alreadyOrdered', 'Reeds besteld')}: {capacityState.usedEnergy}%
      </p>
      <ProgressIndicator id={`progress-${location.name[locale]}`} className="mb-400" progress={capacityState.usedEnergy} />
      <ProducerCta isProducerDetail producerSlug={location.slug} {...{ capacityState, isReserved }} />
    </div>
  )
}

export default ProducerMapCard
